import * as R from 'ramda';


export default function GeneratePRAReportDialogController(
  $rootScope,
  $scope,
  $q,
  ssDialogService,
  alerts,
  loaderService,
  praDataService,
  reportsDataService
) {
  const vm = this;

  vm.submitButtonText = 'Generate Assessment';

  vm.saveDocument = false;
  vm.renderFullReport = true;
  vm.isFullReportIndeterminate = true;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleRunReport = _handleRunReport;
  vm.handleSelectReport = _handleSelectReport;
  vm.handleSectionChange = _handleSectionChange;
  vm.handleSelectSaveDocument = _handleSelectSaveDocument;
  vm.handleSelectAll = _handleSelectAll;
  vm.noneChecked = _noneChecked;
  vm.noneCheckedMessage = _noneCheckedMessage;
  /** ************************************************
   * Event Handlers
   */
  _getReports();

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pra.generatePRAReportDialog);
  }

  function _handleRunReport() {
    console.log('_handleRunReport');
    const dfdSave = $q.defer();

    if ($scope.praGenerateFullReportForm.$valid) {
      const _ids = [];
      R.forEach(
        (report) => {
          if (report.assessmentProcessId > 0 && report.isSelected === true) {
            _ids.push(report.assessmentProcessId);
          }
        },
        vm.reports
      );
      // const reportSections = R.join(',',
      //   R.pluck(
      //     'assessmentProcessId',
      //     R.filter(
      //       R.allPass([
      //         R.propEq('isSelected', true),
      //       ]),
      //       vm.reports
      //     )
      //   ));

      alerts.info('Please Wait! Queueing report. It may take little longer than normal to get the report');
      loaderService.showViewLoader = true;
      const downloadCall = praDataService.generateFullReport(
        {
          assessmentId: vm.assessment.assessmentId,
          name: vm.assessment.name,
          reportSection: _ids.join(),
          renderFullReport: vm.renderFullReport,
          saveDocument: vm.saveDocument,
        }
      );

      downloadCall.then((downloadDocumentResponse) => {
        alerts.success('The PRA assessment document was generated successfully.');
        loaderService.showViewLoader = false;
        reportsDataService.download(downloadDocumentResponse);
        $rootScope.$broadcast('refreshPRAAssessments');
      });

      _handleCloseDialog();
      dfdSave.resolve();
    } else {
      dfdSave.reject();
    }
  }

  function _handleSelectAll() {
    R.forEach(
      (report) => {
        report.isSelected = vm.renderFullReport;
        if (!vm.renderFullReport) {
          vm.saveDocument = false;
        }
      },
      vm.reports
    );
  }

  function _handleSelectReport() {
    const selectedIds = [];
    R.forEach((item) => {
      if (item.assessmentProcessId > 0 && item.isSelected === true) {
        selectedIds.push(item[item.assessmentProcessId]);
      }
    }, vm.reports);
    vm.renderFullReport = selectedIds.length === vm.reports.length - 1;
  }

  function _handleSelectSaveDocument() {
    if (vm.saveDocument === true) {
      vm.submitButtonText = 'Generate Assessment for Board Approval';
      vm.renderFullReport = true;
      _handleSelectAll();
    } else {
      vm.submitButtonText = 'Generate Assessment';
    }
  }

  function _handleSectionChange() {
    let chkboxCtrls;
    vm.renderFullReport = chkboxCtrls
      || chkboxCtrls.length === 0;
    // _SaveDocumentSelection(vm.renderFullReport);
    // _noneChecked(form);
  }

  // Validation
  function _noneChecked() {
    // const selected = R.filter(
    //   R.allPass([
    //     R.propEq('status', 'Approved'),
    //     R.propEq('isSelected', true)
    //   ]),
    //   vm.reports
    // );
    const selected = R.filter(
      R.propEq('isSelected', true),
      vm.reports
    );
    return R.isNil(selected) || selected.length === 0;
  }

  function _noneCheckedMessage(form) {
    let result = null;
    if (form) {
      const selected = angular.element('input:checked[name="renderReportSec"]');

      if (
        selected
        || selected.length === 0
      ) {
        const ctrl = form.renderFullReport;
        if (ctrl) {
          result = ctrl.$error;
        }
      }
    }
    return result;
  }

  /** ************************************************
   * Private Functions
   */

  function _getReports() {
    vm.reports = angular.copy(vm.assessment.assessmentProcesses);
    const sortL = function (a, b) {
      const nameA = a.name.toLowerCase(); // ignore upper and lowercase
      const nameB = b.name.toLowerCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    };
    vm.reports.sort(sortL);

    const _lastProcess = {
      name: '', assessmentProcessId: -1, isSelected: false, notShowCheckBox: true, status: 'Approved', disabled: true
    };
    vm.reports.push(_lastProcess);
    _handleSelectAll();
    checkForBoardReview();
  }

  function checkForBoardReview() {
    let allIsChecked = true;
    R.forEach(
      (process) => {
        if (process.status !== 'Approved') {
          allIsChecked = false;
        }
      },
      vm.reports
    );
    vm.readyForBoardReview = allIsChecked;
  }

  // function _SaveDocumentSelection(ischecked) {
  // var saveDoc = angular.element('input[name="saveDocument"]');
  // if (ischecked) {
  //  saveDoc.removeAttr('disabled');
  // } else {
  //  saveDoc.removeAttr('checked');
  //  saveDoc.attr(
  //  'disabled',
  //  'disabled'
  //  );
  // }
  // }
}

GeneratePRAReportDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'ssDialogService',
  'alerts',
  'loaderService',
  'praDataService',
  'reportsDataService',
];
